module.exports = __webpack_public_path__ + "img/pelvis.48458854.png";